export default "__VITE_PUBLIC_ASSET__2cd76df6__"